/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'paper_clip': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M26.5 16a1 1 0 00-1.707-.708L14.536 25.535a5.002 5.002 0 01-8.158-1.625 5 5 0 011.091-5.45L19.878 5.877a2.999 2.999 0 114.238 4.248L11.707 22.707a1.002 1.002 0 01-1.634-.329 1 1 0 01.226-1.09L20.712 10.7a1 1 0 10-1.426-1.403L8.88 19.878a3 3 0 104.247 4.238l12.409-12.581a5 5 0 10-7.076-7.066L6.05 17.05a7 7 0 109.9 9.9l10.256-10.243a1 1 0 00.293-.707z" _fill="#0B2C62"/>'
  }
})
